import React from 'react'
import { Route, Switch } from 'react-router-dom'

import RoleGuard from '../../components/RoleGuard'
import { USER_IMPORT_ROLES } from '../../constants/roles'
import UserImportDetail from './UserImportDetail'
import UserManageDataList from './UserManageDataList'

export default () => {
    return {
        routes: [
            {
                path: '/manage-user-data/:id',
                exact: true,
                render: ({ match }) => (
                    <RoleGuard roles={USER_IMPORT_ROLES}>
                        <Switch>
                            <Route path={match.path} exact component={UserImportDetail} />
                        </Switch>
                    </RoleGuard>
                ),
            },
            {
                path: '/manage-user-data',
                exact: true,
                render: ({ match }) => (
                    <RoleGuard roles={USER_IMPORT_ROLES}>
                        <Switch>
                            <Route path={match.path} exact component={UserManageDataList} />
                        </Switch>
                    </RoleGuard>
                ),
            },
        ],
    }
}